import React from 'react'
import { useCountdown } from '@hooks/useCountdown'

import Counter from '../Counter'

interface CountdownTimerProperties {
  date: string
  daysLabel: string
  hoursLabel: string
  minutesLabel: string
  secondsLabel: string
}

const CountdownTimer: React.FC<CountdownTimerProperties> = ({
  date,
  daysLabel,
  hoursLabel,
  minutesLabel,
  secondsLabel,
}: CountdownTimerProperties) => {
  const [days, hours, minutes, seconds] = useCountdown(date)

  // Check if all values are valid numbers (not NaN) and countdown hasn't expired
  const areAllValuesValid = [days, hours, minutes, seconds].every((value) => !Number.isNaN(value))
  const hasTimeRemaining = days + hours + minutes + seconds > 0

  return areAllValuesValid && hasTimeRemaining ? (
    <Counter
      days={days}
      hours={hours}
      minutes={minutes}
      seconds={seconds}
      daysLabel={daysLabel}
      hoursLabel={hoursLabel}
      minutesLabel={minutesLabel}
      secondsLabel={secondsLabel}
    />
  ) : null
}

export default CountdownTimer
